import React from "react"
import CalculatorRangeSliderStyle from "./CalculatorRangeSliderStyle.module.css"
import { Tab, Tabs, TabList, TabPanel } from "react-tabs"
import "react-tabs/style/react-tabs.css"
import CalculatorGiTabSlider from "../calculatorGITabSlider/CalculatorGITabSlider"
import CalculateGlycemicLoadSlider from "../calculateGlycemicLoadTabSlider/CalculateGlycemicLoadSlider"
import translate, { keys } from "../../../../../translation/translator"

const CalculatorRangeSlider = ({ locale }) => {
  return (
    <div className={CalculatorRangeSliderStyle.range_slider_holder}>
      <h2 className={CalculatorRangeSliderStyle.title}>
        {translate(keys.TABS_SECTION_TITLE, locale)}
      </h2>
      <div className="calculator-range-tabs-holder">
        <Tabs>
          <TabList>
            <Tab> {translate(keys.GLYCEMIC_INDEX_TAB, locale)}</Tab>
            <Tab>{translate(keys.GLYCEMIC_LOAD_TAB, locale)}</Tab>
          </TabList>

          <TabPanel>
            <CalculatorGiTabSlider locale={locale} />
          </TabPanel>
          <TabPanel>
            <CalculateGlycemicLoadSlider locale={locale} />
          </TabPanel>
        </Tabs>
      </div>
    </div>
  )
}

export default CalculatorRangeSlider
